/* A hook for getting access to the context value */
import React from 'react';
import { ModalContextV3 } from 'Components/utils/Modal/ModalContextV3';

const useModalV3 = () => React.useContext(ModalContextV3);

export default useModalV3;
